import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Excavation from "@/pages/Excavation";
import ExcavationDetail from "@/pages/ExcavationDetail";
import Finance from "@/pages/Finance";
import Parties from "@/pages/Parties";
import AuditLog from "@/pages/AuditLog";
import Reports from "@/pages/Reports";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  const { user, checked } = useAuth();
  const location = useLocation();
  if (!checked) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Yükleniyor...</div>;
  if (!user) return <Navigate to="/giris" replace state={{ from: location }} />;
  return <AppShell>{children}</AppShell>;
}

const ROUTES = [
  ["/", Dashboard], ["/araclar", Vehicles], ["/araclar/:id", VehicleDetail], ["/projeler", Projects],
  ["/projeler/:id", ProjectDetail], ["/hafriyat", Excavation], ["/hafriyat/:id", ExcavationDetail],
  ["/finans", Finance], ["/tanimlar", Parties], ["/islem-gecmisi", AuditLog], ["/raporlar", Reports],
];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/giris" element={<Login />} />
          {ROUTES.map(([path, Page]) => <Route key={path} path={path} element={<Protected><Page /></Protected>} />)}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
